// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2gY_P","log":"ModalInventoryLogs_log__e_d6C","date":"ModalInventoryLogs_date__1_3xr","userName":"ModalInventoryLogs_userName__w-eXw"};